module.exports = __webpack_public_path__ + "sb.401fb94aa3db87da547a.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/sb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/sb.svg
// module chunks = styles